import NewVehiclePill from './pdp/vehicle-pills/new-vehicle-pill';
import ElectricCarBannerAbbreviated from '@/icons/electric-car-banner-abbreviated';
import SavingsV2Pill from './savings-v2-pill';
import SavingsBadgePill from './savings-badge-pill';
import RecentlyAddedPill from './recently-added-pill';
import { Fragment } from 'react/jsx-runtime';

interface VehicleBadgesConfig {
  id: string;
  priority: number;
  component: React.ReactNode;
}

interface VehicleBadgesProps {
  isNewVehicle: boolean;
  isElectric: boolean;
  isRecentlyAdded: boolean;
  savingsCalculatorAvailable?: boolean;
  totalSavingsPerYear?: number;
  savingsV2PillId: string;
  showCoachMark?: boolean;
  fetchSavingsCalculator?: React.MouseEventHandler<HTMLDivElement>;
}

export default function VehicleBadges({
  isNewVehicle,
  isElectric,
  isRecentlyAdded,
  savingsCalculatorAvailable,
  totalSavingsPerYear,
  savingsV2PillId,
  showCoachMark,
  fetchSavingsCalculator,
}: VehicleBadgesProps) {
  const getVehicleBadgesConfigs = (): VehicleBadgesConfig[] => {
    const configs: VehicleBadgesConfig[] = [];

    // Brand New Vehicle - Priority 1
    if (isNewVehicle) {
      configs.push({
        id: 'new-vehicle',
        priority: 1,
        component: <NewVehiclePill />,
      });
    }

    // Recently Added - Priority 2
    if (isRecentlyAdded) {
      configs.push({
        id: 'recently-added',
        priority: 2,
        component: <RecentlyAddedPill />,
      });
    }

    // Electric Vehicle - Priority 3
    if (isElectric) {
      configs.push({
        id: 'electric',
        priority: 3,
        component: <ElectricCarBannerAbbreviated />,
      });
    }

    // Savings Pills - Priority 4
    if (savingsCalculatorAvailable) {
      configs.push({
        id: 'savings-v2',
        priority: 4,
        component: (
          <SavingsV2Pill
            id={savingsV2PillId}
            thickenBorder={showCoachMark}
            permanentShadow={showCoachMark}
            onClick={fetchSavingsCalculator}
          />
        ),
      });
    } else if (totalSavingsPerYear && totalSavingsPerYear > 0) {
      configs.push({
        id: 'savings',
        priority: 4,
        component: <SavingsBadgePill totalSavingsPerYear={totalSavingsPerYear} />,
      });
    }

    return configs;
  };

  const visiblePills = getVehicleBadgesConfigs()
    .sort((a, b) => a.priority - b.priority)
    .slice(0, 2);

  return (
    <div className="absolute top-[16px] z-1 flex w-full flex-row justify-between gap-[4px] px-[16px]">
      {visiblePills.map(({ id, component }) => (
        <Fragment key={id}>{component}</Fragment>
      ))}
    </div>
  );
}
